import {
  Box,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { convertBase64 } from "../../../Base/helper/baseFunctions";
import { v4 as uuidv4 } from "uuid";
import { AddPreScreenTemplateResponseHelper } from "../../helper/AtsFormTemplateResponseHelper";
import { useEffect } from "react";
// import { PreScreenComponentsRender } from "./PreScreenComponentsRender";
import UnauthorizedBase from "../../../Base/views/UnauthorizedBase";
import { useParams } from "react-router";
import {
  DeleteEmailTokenHelper,
  GetEmailTokenHelper,
} from "../../../Ancillary/EmailToken/helper/EmailTokenHelper";
import PreScreenTokenNotFound from "../../../Base/views/PreScreenTokenNotFound";
import history from "../../../../../history";
import PreScreenAssessment from "../../../ATS/views/ATSJobPost/AIJobPrescreening/PreScreenAssessment";
import VideoAssessment from "../../../ATS/views/ATSJobPost/AIJobPrescreening/VideoAssessment";
import assessmentSuccess from "../../../../../Image/assessment_success.png";


const PreScreenResponse = ({ data, userData, carrerPortal, domainname, externalData, setPop }) => {
  const { guid } = useParams();
  const [candidateData, setCandidateData] = useState({});
  const [viewMode, setViewMode] = useState("Loading");
  const [id, setId] = useState("");
  const [currentStep, setCurrentStep] = useState("LOADING");
  const [assessmentData, setAssessmentData] = useState({
      formQuestions: [],
      videoQuestions: [],
      answers: {
        form_response: [],
        video_response: [],
      },
  });
  const domain_name = guid?.split("=")?.[1] || userData?.domain || domainname;
  const candidateJobId = guid ? id : externalData?.fn_ats_ext_addcandidate;

  useEffect(() => {
    setTimeout(() => {
      if (guid) {
        GetEmailTokenHelper({
          domain: guid?.split("=")?.[1],
          token: guid,
        }).then((res) => {
          if (res?.data?.data?.[0]?.email_tokens_id) {
            const jsonData = res?.data?.data?.[0]?.json_data;
            setCandidateData({
              ...jsonData?.jobData,
              domain: guid?.split("=")?.[1],
              candidate_name : jsonData?.kanban_data?.full_name,
              isEmail: true,
              domain_name: domain_name
            });
            setId(jsonData?.kanban_data?.candidate_job_id)
            setViewMode("Feedback");
          } else {
            setViewMode("TokenNotFound");
          }
        });
      } else {
        setCandidateData({ ...data, domain_name: domain_name }); //JobDashboard Job link Shared 
      }
    }, 1000);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (candidateData?.prescreen_template_id) { 
      if(carrerPortal) {  // JobDashboard Job link Shared 
        setViewMode("Feedback");
        setPreScreenData();
      } else {  //PreScreening Request through email
        setViewMode("Feedback");
        setPreScreenData();
      }
      if (candidateData?.video_prescreen_template_json?.length > 0 && candidateData?.is_ai_job) {
        // transcript is used in video assessment only  
        transcriptBrowserSupportCheck();
      }
    }
    //eslint-disable-next-line
  }, [candidateData]);
  const setPreScreenData = () => {
    //PreScreening Request through candidate received email & JobDashboard Job link Shared
    setAssessmentData((prev) => ({
      ...prev,
      formQuestions: candidateData?.prescreen_template_json?.length
        ? candidateData?.prescreen_template_json
        : [],
      videoQuestions: candidateData?.video_prescreen_template_json?.length
        ? candidateData?.video_prescreen_template_json
        : [],
    }));
    if (candidateData?.prescreen_template_json?.length > 0) {
      setCurrentStep("PRESCREEN_ASSESSMENT");
    } 
    else if (candidateData?.video_prescreen_template_json?.length > 0 && candidateData?.is_ai_job) {
      setCurrentStep("VIDEO_ASSESSMENT");
    }
  }
  const transcriptBrowserSupportCheck = () => {
    const speechSupported = "webkitSpeechRecognition" in window || "SpeechRecognition" in window;
    if (!speechSupported) {
      alert( "Your browser does not support live transcription. Please use Google Chrome for the best experience.");
    } 
  }
  const handleResponseSubmit = async () => {
    setViewMode("Loading");
    const questions = assessmentData?.formQuestions || [];
    const answers = assessmentData?.answers?.form_response || {};
    const processedFormResponse = {};

    for (const field of questions) {
      const fieldName = field.name;
      const fieldType = field.type;
      const fieldValue = answers[fieldName];

      if (fieldType === "file" && fieldValue instanceof File) {
        const b64string = await convertBase64(fieldValue);
        const ext = fieldValue.name.split(".").pop();

        const filename = `${domain_name}/ATS/PreScreenQuestions/${uuidv4()}.${ext}`;

        processedFormResponse[fieldName] = {
          type: fieldType,
          value: filename,
          file: b64string,
          content_type: fieldValue.type,
        };
      } else {
        processedFormResponse[fieldName] = {
          type: fieldType,
          value: fieldValue || null,
        };
      }
    }
      const answerData = assessmentData?.answers || {};

      AddPreScreenTemplateResponseHelper({
        workspace: domain_name,
        user_id: candidateData?.createdby || null,
        prescreen_template_id: candidateData?.prescreen_template_id,
        prescreen_response: Object.keys(processedFormResponse).length ? JSON.stringify(processedFormResponse) : null,
        candidate_job_id: guid
          ? id
          : externalData?.fn_ats_ext_addcandidate,
        video_prescreen_response: answerData?.video_response?.length ? JSON.stringify(answerData?.video_response) : null,
      }).then((res) => {
        if (res?.data?.statuscode === 200) {
          setViewMode("FeedbackSuccess");
          if (guid) {
            DeleteEmailTokenHelper({
              domain: guid?.split("=")?.[1],
              token: guid,
            });
          }
          if(carrerPortal){
            setPop(true)
            setTimeout(() => history.push("/"), 3000);

          }
        } else {
          setViewMode("Feedback");
        }
      });
    
  };
  const confirmPreScreenSubmit = (data) => {
    setAssessmentData((prev) => ({
      ...prev,
      answers: {
        ...prev?.answers,
        form_response: data,
      },
    }))
    if(assessmentData?.videoQuestions?.length > 0 && candidateData?.is_ai_job) {
      setCurrentStep("VIDEO_ASSESSMENT");
    } else {
      handleResponseSubmit(data);
    }
  }
  const renderComponent = () => {
    switch (currentStep) {
      case "PRESCREEN_ASSESSMENT":
        return (
          <PreScreenAssessment
            formQuestions={assessmentData?.formQuestions}
            setCandidateAnswers={(data) =>
              setAssessmentData((prev) => ({
                ...prev,
                answers: {
                  ...prev?.answers,
                  form_response: data,
                },
              }))
            }
            name={externalData?.candidate_name || candidateData?.candidate_name}
            handleConfirmSubmit={confirmPreScreenSubmit}
            candidateData={candidateData}
          />
        );

      case "VIDEO_ASSESSMENT":
        return (
          <VideoAssessment
            videoQuestions={assessmentData?.videoQuestions}
            candidateAnswers={assessmentData?.answers}
            setCandidateAnswers={(data) =>
              setAssessmentData((prev) => ({
                ...prev,
                answers: {
                  ...prev?.answers,
                  video_response: data?.video_response,
                },
              }))
            }
            handleResponseSubmit={handleResponseSubmit}
            name={externalData?.candidate_name || candidateData?.candidate_name}
            jobTitle={candidateData?.job_title}
            candidateData={candidateData}
            candidateJobId={candidateJobId}
          />
        );
      default:
        return null;
    }
  };
  return (
    <>
      {carrerPortal ? (
        <>
          <Box sx={{ paddingTop:"10px", width:"100%"}}>
            {viewMode === "Loading" ? (
              <LoadingComponent />
            ) : viewMode === "Feedback" ? (
              <Box 
                sx={{
                  padding: "5px 20px",
                  width: "90%",
                  margin: "auto",
                  overflowY: "auto",
                  background: "#ffffff",
                  borderRadius: "8px",
                }}
              >
                {renderComponent()}
              </Box>
            ) : viewMode === "TokenNotFound" ? (
              <PreScreenTokenNotFound />
            ) : (
              viewMode === "FeedbackSuccess" && (
                <Grid item>
                  <Box
                    className="response-main"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      maxWidth: "400px",
                    }}
                  >
                    <Typography
                       padding={"20px"}
                      textAlign={"center"}
                      component="h1"
                      variant="h3"
                      fontWeight={700}
                      lineHeight={1.5}
                    >
                      Pre-Screening assessment submitted successfully!
                    </Typography>
                  </Box>
                </Grid>
              )
            )}
          </Box>
        </>
      ) : (
        <UnauthorizedBase>
          <Box className="bg_form_main" sx={{minHeight:"90vh", paddingTop:"50px", width:"100%"}}>
            {viewMode === "Loading" ? (
              <LoadingComponent />
            ) : viewMode === "Feedback" ? (
              <Box 
                sx={{
                  padding: "5px 20px",
                  width: "90%",
                  margin: "auto",
                  overflowY: "auto",
                  background: "#ffffff",
                  borderRadius: "8px",
                }}
              >
                {renderComponent()}
              </Box>
            ) : viewMode === "TokenNotFound" ? (
              <PreScreenTokenNotFound />
            ) : (
              viewMode === "FeedbackSuccess" && (
                <Grid item>
                  <Box
                    className="response-main"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      maxWidth: "400px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: 280,
                      }}
                    >
                      <Box
                        component="img"
                        src={assessmentSuccess}
                        alt="Assessment"
                        sx={{
                          width: "100%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                    <Typography
                      textAlign={"center"}
                      component="h1"
                      variant="h3"
                      fontWeight={700}
                      lineHeight={1.5}
                      padding={"20px"}
                    >
                      Pre-Screening assessment submitted successfully!
                    </Typography>
                    <Typography
                      padding={"10px"}
                      textAlign={"center"}
                      variant="body1"
                      color="text.secondary"
                    >
                      All your responses have been successfully recorded! You
                      may now leave the page.
                    </Typography>
                  </Box>
                </Grid>
              )
            )}
          </Box>
        </UnauthorizedBase>
      )}
    </>
  );
};
export default PreScreenResponse;


const LoadingComponent = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 900,
          borderRadius: 3,
        }}
      >
        <Box display="flex" justifyContent="center" mb={3}>
          <Skeleton animation="wave" width="100%" height={40} />
        </Box>

        <Skeleton
          animation="wave"
          variant="rectangular"
          height={300}
          width="100%"
          sx={{ borderRadius: 2 }}
        />

        <Box display="flex" justifyContent="center" mt={3}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={50}
            width="100%"
            sx={{ borderRadius: 2 }}
          />
        </Box>
      </Box>
    </Box>
  );
};